/**
 * 주문자명 통일(운영 1안, BE order #145) — 목록의 '주문자명'은 주문서에 입력한 이름(ordererName),
 * 회원 계정 이름(buyerName)은 '회원명'으로 따로 보인다.
 */
export interface OrdererNameSource {
  ordererName?: string | null;
  buyerName?: string | null;
}

/** 주문자명. BE 반영 전(ordererName 없음)에는 예전처럼 회원명을 쓴다. */
export const ordererNameOf = (r: OrdererNameSource): string | null => r.ordererName ?? r.buyerName ?? null;

/** 회원명 — 주문자명과 다를 때만. 비회원·회원 조회 실패면 null. */
export const memberNameOf = (r: OrdererNameSource): string | null =>
  r.buyerName && r.ordererName && r.buyerName !== r.ordererName ? r.buyerName : null;
